<template>
  <div class="alertContainer">
    <div class="alertContent">
      <div class="title" v-if="title">{{ title }}</div>
      <div class="body">
        <div class="text" :class="index===text.length-1?'last-text':''" v-for="(item,index) in text" :key="index">
          {{ item }}
        </div>
        <div class="yes-btn" v-if="yesText" @click="yesClick">{{ yesText }}</div>
        <div class="close-btn" v-if="closeText" @click="closeClick">{{ closeText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert2',
  props: ['yesClick', 'closeClick', 'yesText', 'closeText', 'text', 'title'],
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.alertContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .8);
  z-index: 10;

  .alertContent {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 86.666vw;
    height: max-content;
    transform: translate(-50%, -50%);
    border-radius: 2.777vw;
    background: #202020;
    border: 0.277vw solid #737373;
    padding-bottom: 7.5vw;

    .title {
      font-size: 6vw;
      line-height: 13vw;
      font-weight: bold;
      color: #543200;
      text-align: center;
      background: #F6D9AA;
    }

    .body {
      padding-top: 13vw;

      .text {
        font-size: 4.722vw;
        line-height: calc(4.722vw + 3px);
        font-weight: 400;
        letter-spacing: -0.05em;
        text-align: center;
        color: #c4c4c4;
        padding: 0 7vw;
      }

      .last-text {
        margin-bottom: 13vw;
      }

      .yes-btn {
        margin: auto;
        background: #F6D9AA;
        border-radius: 1.38vw;
        text-align: center;
        color: #000000;
        width: 73.055vw;
        line-height: 9.444vw;
        height: 9.444vw;
        font-size: 4.166vw;
        font-weight: 600;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
      }

      .close-btn {
        margin: 4.166vw auto 0 auto;
        background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
        border: 0.277vw solid #E2C28F;
        border-radius: 1.38vw;
        text-align: center;
        width: 73.055vw;
        line-height: 9.444vw;
        height: 9.444vw;
        font-size: 4.166vw;
        font-weight: 600;
        color: #E1C18D;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmWin/Alert2.vue